import type { Event } from "@apps/gwservice/types"
import { EventList } from "~/features/calendar/components/event-list"
import { ScrollCalendar } from "~/features/calendar/components/scroll-calendar"
import { topicContentQueryKeys } from "../query-keys"

interface Props {
  events: Event[]
  topicId: number
}

export function CalendarFeed({ events, topicId }: Props) {
  return (
    <ScrollCalendar events={events}>
      <EventList events={events} queryKey={topicContentQueryKeys(topicId)} />
    </ScrollCalendar>
  )
}
